import React from 'react';
import { useGridContext } from './context';

type Row = HtmlPropsNoRef<HTMLDivElement>;

const Row = (props: Row): JSX.Element => {
    const { sortedBreakpoints: outerBreakpoints } = useGridContext();

    const css = React.useMemo(() => Object.fromEntries(
        outerBreakpoints.map(([, { query, gap, columns }]) => [query, {
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gridAutoFlow: 'dense',
            gridColumnGap: `${gap}px`,
        }]),
    ), [outerBreakpoints]);

    return (
        <div
            css={{
                ...css,
                width: '100%',
                margin: 'auto',
                position: 'relative',
            }}
            className="__row"
            {...props}
        />
    );
};

export default Row;
